import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataComparisonInfo } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function ComparisonInfo(props: IElementDataComparisonInfo) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const {
        elementType = '',
        metricTileDisplayPctVariance,
        metricTileDisplayVarianceMode,
        metricTileDisplayVarianceFormatted,
        metricTileDisplayVarianceTargetValueFormatted,
        pctVarianceText = '',
        isReportMetric,
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'comparison_info';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);
    const isAbsoluteMode = metricTileDisplayVarianceMode === 'absolute';
    const isTargetComparison = !!metricTileDisplayVarianceTargetValueFormatted;

    if (
        !fieldMetadataDisplay ||
        (!['metric', 'multi-metric chart'].includes(elementType) && !isReportMetric) ||
        metricTileDisplayPctVariance === null ||
        metricTileDisplayPctVariance === undefined ||
        (isAbsoluteMode && metricTileDisplayVarianceFormatted === undefined)
    )
        return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>
                {t(
                    `element_data_label.${isAbsoluteMode ? 'comparison_info_absolute' : fieldKey}${
                        isTargetComparison ? '_target' : ''
                    }`,
                )}
            </ElementDataRowLabel>
            <ElementDataRowValue>
                {metricTileDisplayPctVariance > 0
                    ? t('element_data_common.up') + ' '
                    : metricTileDisplayPctVariance < 0
                      ? t('element_data_common.down') + ' '
                      : ''}
                {isAbsoluteMode ? metricTileDisplayVarianceFormatted : `${Math.abs(metricTileDisplayPctVariance).toFixed(2)}%`}{' '}
                {'from last day' == pctVarianceText ? t('element_data_common.from_yesterday') : pctVarianceText}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
